import { useEffect, useRef, useCallback } from 'react';
import { toast } from 'sonner';
import { getEspStatus } from '@/lib/api';

const useNotification = () => {
  const wasOnlineRef = useRef(null);

  const notify = useCallback((title, body, type = 'error') => {
    if (type === 'error') toast.error(`${title}: ${body}`);
    else toast.success(`${title}: ${body}`);

    if ('Notification' in window && Notification.permission === 'granted') {
      try {
        new Notification(title, {
          body,
          icon: '/favicon.ico',
          badge: '/favicon.ico',
        });
      } catch { /* ignore */ }
    }
  }, []);

  const check = useCallback(async () => {
    try {
      const res = await getEspStatus();
      const isOnline = res.data?.online || false;

      if (wasOnlineRef.current === true && !isOnline) {
        notify('ESP8266 Bağlantısı Kesildi', 'Röle kartı ile bağlantı kaybedildi!', 'error');
      } else if (wasOnlineRef.current === false && isOnline) {
        notify('ESP8266 Bağlandı', 'Röle kartı bağlantısı yeniden kuruldu.', 'success');
      }

      wasOnlineRef.current = isOnline;
    } catch { /* silent */ }
  }, [notify]);

  useEffect(() => {
    // Bildirim izni iste
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    check();
    const id = setInterval(check, 30000);
    return () => clearInterval(id);
  }, [check]);
};

export default useNotification;
